var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03685 21.3248C4.45216 21.5821 4.15982 21.7107 3.98042 21.6542C3.8249 21.6052 3.70303 21.4835 3.65387 21.328C3.59717 21.1487 3.72545 20.8562 3.98203 20.2712L11.2634 3.66971C11.495 3.14163 11.6108 2.8776 11.7727 2.79678C11.9133 2.72659 12.0787 2.72659 12.2193 2.79678C12.3812 2.8776 12.497 3.14163 12.7287 3.66971L20.01 20.2712C20.2666 20.8562 20.3949 21.1487 20.3382 21.328C20.289 21.4835 20.1671 21.6052 20.0116 21.6542C19.8322 21.7107 19.5399 21.5821 18.9552 21.3248L12.3182 18.4045C12.1995 18.3523 12.1402 18.3262 12.0785 18.3159C12.0239 18.3067 11.9681 18.3067 11.9135 18.3159C11.8519 18.3262 11.7925 18.3523 11.6738 18.4045L5.03685 21.3248Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.43427624ce7729f9a43b512e21d36fb6.svg";
export { ForwardRef as ReactComponent };